import { analyzeLoading, analyzeLoadingDone, currentUser, analyzeStadgarLoading, analyzeStadgarLoadingDone, 
         analyzeEnergyLoading, analyzeEnergyLoadingDone, createRedovisningExpertLoading, createRedovisningExpertLoadingDone } from '../store/store.js';
import { fetchBrf } from './utils.js';
import { rateBrf } from '../components/Rating.svelte';
import { get } from 'svelte/store';

export async function handleAnalyzeBrf(fileName, coreId){ 
    analyzeLoading.set(true);
    analyzeLoadingDone.set(false);
    let url = 'https://boanalys-backend-324523837899.europe-north1.run.app/analyze_document'

    const queryParams = new URLSearchParams({ file_name: fileName });
    if (coreId) {
        queryParams.append('core_id', coreId);
    }

    // Get the current value of the store
    const user = get(currentUser);
    
    const response = await fetch(`${url}?${queryParams.toString()}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user?.accessToken}`,
        },
    });

    if (!response.ok) {
        throw new Error('Failed to trigger backend function');
    }

    const data = await response.json();
    console.log('Backend function response:', data);

    const { core_id } = data;
    console.log('Extracted core_id:', core_id);

    analyzeLoading.set(false);
    analyzeLoadingDone.set(true);

    fetchBrf(core_id); 
    await rateBrf(core_id);
    fetchBrf(core_id); 

    return core_id;
}

export async function handleCreateBrfExpert(fileName, coreId) {
    console.log(`Attempting to create expert for:`, fileName, "CoreID:", coreId);

    let url = 'https://brf-analyze-backend-tnkskvn76a-lz.a.run.app/extract_text_from_file_name';
    const queryParams = new URLSearchParams();
    // Use the specific parameter name for the file based on type if needed, or a generic one
    queryParams.append('file_name', fileName); // Generic, backend can differentiate if needed

    if (coreId) {
        queryParams.append('core_id', coreId);
    }

    const storeState = get(currentUser);
    const response = await fetch(`${url}?${queryParams.toString()}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${storeState?.accessToken}`,
        },
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(`Failed to create ${expertTypeLogName} expert. Status: ${response.status}, Message: ${errorText}`);
        throw new Error(`Failed to create ${expertTypeLogName} expert`);
    }

    const data = await response.json();
    console.log(`Create ${expertTypeLogName} expert response:`, data);

    createRedovisningExpertLoading.set(true);
    createRedovisningExpertLoadingDone.set(false);
}

export async function analyzeUploadedStadgar(fileName, coreId) {
    analyzeStadgarLoading.set(true);
    analyzeStadgarLoadingDone.set(false);
    let url = 'https://brf-analyze-backend-tnkskvn76a-lz.a.run.app/analyze_stadgar_structured_initialized';

    const queryParams = new URLSearchParams({ stadgar_file_name: fileName });
    if (coreId) {
        queryParams.append('core_id', coreId);
    }

    const storeState = get(currentUser);

    const response = await fetch(`${url}?${queryParams.toString()}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${storeState?.accessToken}`,
        },
    });

    if (!response.ok) {
        analyzeStadgarLoading.set(false);
        throw new Error('Failed to trigger stadgar analysis backend function');
    }

    const data = await response.json();
    analyzeStadgarLoading.set(false);
    analyzeStadgarLoadingDone.set(true);
    fetchBrf(coreId);
    return data;
}

export async function analyzeUploadedEnergy(fileName, coreId) {
    analyzeEnergyLoading.set(true);
    analyzeEnergyLoadingDone.set(false);
    let url = 'https://brf-analyze-backend-tnkskvn76a-lz.a.run.app/analyze_energy_gtp_4o_structured_initialized';

    const queryParams = new URLSearchParams({ energy_file_name: fileName });
    if (coreId) {
        queryParams.append('core_id', coreId);
    }

    const storeState = get(currentUser);

    const response = await fetch(`${url}?${queryParams.toString()}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${storeState?.accessToken}`,
        },
    });

    if (!response.ok) {
        analyzeEnergyLoading.set(false);
        const errorText = await response.text();
        console.error(`Failed to trigger energy analysis. Status: ${response.status}, Message: ${errorText}`);
        throw new Error('Failed to trigger energy analysis backend function');
    }

    const data = await response.json();
    analyzeEnergyLoading.set(false);
    analyzeEnergyLoadingDone.set(true);
    fetchBrf(coreId);
    return data;
}